import { h, Fragment } from 'preact';
import { formatMoney } from 'utils/format-money';
import { useKitProduct } from './product-context';

const KitPrice = () => {
  const { kitProducts } = useKitProduct();
  if (!kitProducts) {
    return null;
  }

  const prices = kitProducts.reduce(
    (acc, product) => {
      acc.price += product.selectedVariant.price;
      if (
        Boolean(product.selectedVariant.compareAtPrice) &&
        acc.compareAtPrice !== null
      ) {
        acc.compareAtPrice += product.selectedVariant.compareAtPrice;
      } else {
        acc.compareAtPrice = null;
      }
      return acc;
    },
    { price: 0, compareAtPrice: 0 },
  );

  return (
    <div className="text-[14px] leading-[18px] mb-[30px]">
      <span role="price" className="py-[6px] inline-block mr-[10px]">
        {formatMoney({ amount: prices.price }, true)}
      </span>
      {prices.compareAtPrice && (
        <>
          <del className="mr-[10px] text-red py-[6px]">
            {formatMoney({ amount: prices.compareAtPrice }, true)}
          </del>
        </>
      )}
    </div>
  );
};

export default KitPrice;
